import { useRouterState } from '@tanstack/react-router';
import { createSlideInMenuAnchorLink } from 'components/SlideInMenu/SlideInMenu.helpers';
import React from 'react';
import computeDynamicDomId from 'utils/functions/computeDynamicDomId';
import { MenuTabsProps } from './MenuTabs.type';
import { MenuTabLink, MenuTabsWrapper } from './style/MenuTabs.style';

const MenuTabs: React.FC<MenuTabsProps> = function MenuTabs({
  menuTabList,
  listComponent = MenuTabsWrapper,
  linkComponent = MenuTabLink,
  domIdPrefix,
  ...otherProps
}) {
  const {
    location: { hash },
  } = useRouterState();
  const ListComponent = listComponent;
  const LinkComponent = linkComponent;

  if (!Array.isArray(menuTabList)) {
    return <MenuTabsWrapper />;
  }

  return (
    <ListComponent {...otherProps}>
      {menuTabList.map(({ label }, index) => {
        const to = createSlideInMenuAnchorLink(index + 1);
        const isCurrent = hash === to;
        return (
          <li key={to}>
            <LinkComponent
              id={computeDynamicDomId(domIdPrefix, index)}
              hash={to}
              replace
              role="tab"
              aria-selected={isCurrent}
              aria-controls={computeDynamicDomId(domIdPrefix, 'tab-panel')}
              className={isCurrent ? 'active-tab' : undefined}
              aria-current={isCurrent ? 'page' : undefined}
            >
              {label}
            </LinkComponent>
          </li>
        );
      })}
    </ListComponent>
  );
};

export default MenuTabs;
